<template>
  <div
    v-lazy-container="{ selector: 'img' }"
    class="grid"
  >
    <a
      v-for="(img, i) in images"
      :key="`${img.alt}-${i}`"
      href="#"
      :title="img.alt"
      @click.prevent="$emit('click', { img, index: i });"
    >
      <img
        :data-src="img.src"
        :alt="img.alt"
      >
    </a>
  </div>
</template>

<script>
export default {
  name: 'images-grid',
  props: {
    images: {
      type: Array,
      required: true,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.grid {
  display: flex;
  flex-wrap: wrap;

  a {
    display: block;
    position: relative;
    width: calc(25% - 12px);
    height: 0;
    overflow: hidden;
    padding-bottom: calc(25% - 12px);
    margin: 0 16px 16px 0;

    &:nth-child(4n) {
      margin-right: 0;
    }

    &:nth-last-child(-n+4) {
      margin-bottom: 0;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
      background-color: #faebd7;
    }
  }
}
</style>
